import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React from 'react';
import { SingleRatingStar } from './single-rating-star.esm.js';
import { starRatingStyles } from '../star-rating-styles.esm.js';

var _excluded = ["onClick", "disabled", "valueArray", "inactiveColor", "variant"];
var defaultInactiveColor = 'white';
var defaultVariant = 'sm';
var StarRatingUI = function StarRatingUI(props) {
  var onClick = props.onClick,
    disabled = props.disabled,
    valueArray = props.valueArray,
    _props$inactiveColor = props.inactiveColor,
    inactiveColor = _props$inactiveColor === void 0 ? defaultInactiveColor : _props$inactiveColor,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? defaultVariant : _props$variant,
    rest = _objectWithoutProperties(props, _excluded);
  var _starRatingStyles = starRatingStyles({
      size: variant
    }),
    container = _starRatingStyles.container,
    star = _starRatingStyles.star;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: container()
  }, rest), valueArray.map(function (x, i) {
    return /*#__PURE__*/React.createElement(SingleRatingStar, {
      key: i,
      value: x,
      disabled: disabled,
      onClick: !disabled && onClick ? onClick(i) : undefined,
      inactiveColor: inactiveColor,
      classNames: star()
    });
  }));
};

export { StarRatingUI };
//# sourceMappingURL=star-rating-ui.esm.js.map
